import { render, staticRenderFns } from "./CompanyPTOPolicy.vue?vue&type=template&id=1f832dd2&scoped=true&"
import script from "./CompanyPTOPolicy.vue?vue&type=script&lang=ts&"
export * from "./CompanyPTOPolicy.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyPTOPolicy.vue?vue&type=style&index=0&id=1f832dd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f832dd2",
  null
  
)

export default component.exports